/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FlagCreate,
  HTTPValidationError,
  ReviewDecisionUpdate,
  SubmissionRead,
  SubmissionReadFull,
  SubmissionResultRead,
  SubmissionResultReadWithOutput,
} from '../models/index';
import {
    FlagCreateFromJSON,
    FlagCreateToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ReviewDecisionUpdateFromJSON,
    ReviewDecisionUpdateToJSON,
    SubmissionReadFromJSON,
    SubmissionReadToJSON,
    SubmissionReadFullFromJSON,
    SubmissionReadFullToJSON,
    SubmissionResultReadFromJSON,
    SubmissionResultReadToJSON,
    SubmissionResultReadWithOutputFromJSON,
    SubmissionResultReadWithOutputToJSON,
} from '../models/index';

export interface CreateSubmissionByCodeIdRequest {
    codeId: string;
}

export interface FlagResultRequest {
    submissionId: string;
    testCaseId: string;
    flagCreate: FlagCreate;
}

export interface GetSubmissionRequest {
    submissionId: string;
}

export interface GetSubmissionByCodeIdRequest {
    codeId: string;
}

export interface GetSubmissionResultRequest {
    submissionId: string;
    testCaseId: string;
}

export interface GetSubmissionsRequest {
    competitorId?: string | null;
    problemId?: string | null;
    userId?: string | null;
}

export interface RejudgeSubmissionRequest {
    submissionId: string;
}

export interface RemoveVariantRequest {
    submissionId: string;
    testCaseId: string;
}

export interface ReviewResultRequest {
    submissionId: string;
    testCaseId: string;
    reviewDecisionUpdate: ReviewDecisionUpdate;
}

export interface RunSubmissionRequest {
    submissionId: string;
    xOrganizationID?: string | null;
}

export interface ScoreSubmissionRequest {
    submissionId: string;
    xOrganizationID?: string | null;
}

export interface UnflagResultRequest {
    submissionId: string;
    testCaseId: string;
}

/**
 * 
 */
export class SubmissionsApi extends runtime.BaseAPI {

    /**
     * Submit the caller\'s own saved code for practice judging; 403 for another user\'s code, 429 with Retry-After within the submission cooldown.
     * Create Submission By Code Id
     */
    async createSubmissionByCodeIdRaw(requestParameters: CreateSubmissionByCodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionRead>> {
        if (requestParameters['codeId'] == null) {
            throw new runtime.RequiredError(
                'codeId',
                'Required parameter "codeId" was null or undefined when calling createSubmissionByCodeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/code/{code_id}`.replace(`{${"code_id"}}`, encodeURIComponent(String(requestParameters['codeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionReadFromJSON(jsonValue));
    }

    /**
     * Submit the caller\'s own saved code for practice judging; 403 for another user\'s code, 429 with Retry-After within the submission cooldown.
     * Create Submission By Code Id
     */
    async createSubmissionByCodeId(requestParameters: CreateSubmissionByCodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionRead> {
        const response = await this.createSubmissionByCodeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Flag a result for review with an optional comment. The author of the submission or a member of its team, while the feedback level shows results.
     * Flag Result
     */
    async flagResultRaw(requestParameters: FlagResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionResultRead>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling flagResult().'
            );
        }

        if (requestParameters['testCaseId'] == null) {
            throw new runtime.RequiredError(
                'testCaseId',
                'Required parameter "testCaseId" was null or undefined when calling flagResult().'
            );
        }

        if (requestParameters['flagCreate'] == null) {
            throw new runtime.RequiredError(
                'flagCreate',
                'Required parameter "flagCreate" was null or undefined when calling flagResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/{submission_id}/results/{test_case_id}/flag`.replace(`{${"submission_id"}}`, encodeURIComponent(String(requestParameters['submissionId']))).replace(`{${"test_case_id"}}`, encodeURIComponent(String(requestParameters['testCaseId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FlagCreateToJSON(requestParameters['flagCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionResultReadFromJSON(jsonValue));
    }

    /**
     * Flag a result for review with an optional comment. The author of the submission or a member of its team, while the feedback level shows results.
     * Flag Result
     */
    async flagResult(requestParameters: FlagResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionResultRead> {
        const response = await this.flagResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return one submission with its results. 404 if missing or not readable by the caller.
     * Get Submission
     */
    async getSubmissionRaw(requestParameters: GetSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionReadFull>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling getSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/{submission_id}`.replace(`{${"submission_id"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionReadFullFromJSON(jsonValue));
    }

    /**
     * Return one submission with its results. 404 if missing or not readable by the caller.
     * Get Submission
     */
    async getSubmission(requestParameters: GetSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionReadFull> {
        const response = await this.getSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the submissions for a code\'s problem that the caller may read. Login required.
     * Get Submission By Code Id
     */
    async getSubmissionByCodeIdRaw(requestParameters: GetSubmissionByCodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubmissionReadFull>>> {
        if (requestParameters['codeId'] == null) {
            throw new runtime.RequiredError(
                'codeId',
                'Required parameter "codeId" was null or undefined when calling getSubmissionByCodeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/code/{code_id}`.replace(`{${"code_id"}}`, encodeURIComponent(String(requestParameters['codeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubmissionReadFullFromJSON));
    }

    /**
     * List the submissions for a code\'s problem that the caller may read. Login required.
     * Get Submission By Code Id
     */
    async getSubmissionByCodeId(requestParameters: GetSubmissionByCodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubmissionReadFull>> {
        const response = await this.getSubmissionByCodeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return one test case result with its output. 404 if the submission is not readable.
     * Get Submission Result
     */
    async getSubmissionResultRaw(requestParameters: GetSubmissionResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionResultReadWithOutput>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling getSubmissionResult().'
            );
        }

        if (requestParameters['testCaseId'] == null) {
            throw new runtime.RequiredError(
                'testCaseId',
                'Required parameter "testCaseId" was null or undefined when calling getSubmissionResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/{submission_id}/results/{test_case_id}`.replace(`{${"submission_id"}}`, encodeURIComponent(String(requestParameters['submissionId']))).replace(`{${"test_case_id"}}`, encodeURIComponent(String(requestParameters['testCaseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionResultReadWithOutputFromJSON(jsonValue));
    }

    /**
     * Return one test case result with its output. 404 if the submission is not readable.
     * Get Submission Result
     */
    async getSubmissionResult(requestParameters: GetSubmissionResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionResultReadWithOutput> {
        const response = await this.getSubmissionResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the submissions the caller may read, optionally filtered. Login required.
     * Get Submissions
     */
    async getSubmissionsRaw(requestParameters: GetSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubmissionRead>>> {
        const queryParameters: any = {};

        if (requestParameters['competitorId'] != null) {
            queryParameters['competitor_id'] = requestParameters['competitorId'];
        }

        if (requestParameters['problemId'] != null) {
            queryParameters['problem_id'] = requestParameters['problemId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubmissionReadFromJSON));
    }

    /**
     * List the submissions the caller may read, optionally filtered. Login required.
     * Get Submissions
     */
    async getSubmissions(requestParameters: GetSubmissionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubmissionRead>> {
        const response = await this.getSubmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queue one submission without points to be evaluated and judged again, for a failed or stuck judgement. Reviewers only: organizers, and for practice submissions the organization admin or workshop mentor of the author. 404 when missing or unreadable, 403 for a non-reviewer, 409 when the submission already has points or a test case of the problem is not prepared, 422 for a problem that is not evaluatable.
     * Rejudge Submission
     */
    async rejudgeSubmissionRaw(requestParameters: RejudgeSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling rejudgeSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/{submission_id}/rejudge`.replace(`{${"submission_id"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Queue one submission without points to be evaluated and judged again, for a failed or stuck judgement. Reviewers only: organizers, and for practice submissions the organization admin or workshop mentor of the author. 404 when missing or unreadable, 403 for a non-reviewer, 409 when the submission already has points or a test case of the problem is not prepared, 422 for a problem that is not evaluatable.
     * Rejudge Submission
     */
    async rejudgeSubmission(requestParameters: RejudgeSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.rejudgeSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove the variant a result matched (accepted by mistake); reviewers only. Every result that matched it is rejudged and loses its review decision. 400 when the result matched the official output or nothing.
     * Remove Variant
     */
    async removeVariantRaw(requestParameters: RemoveVariantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling removeVariant().'
            );
        }

        if (requestParameters['testCaseId'] == null) {
            throw new runtime.RequiredError(
                'testCaseId',
                'Required parameter "testCaseId" was null or undefined when calling removeVariant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/{submission_id}/results/{test_case_id}/variant`.replace(`{${"submission_id"}}`, encodeURIComponent(String(requestParameters['submissionId']))).replace(`{${"test_case_id"}}`, encodeURIComponent(String(requestParameters['testCaseId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove the variant a result matched (accepted by mistake); reviewers only. Every result that matched it is rejudged and loses its review decision. 400 when the result matched the official output or nothing.
     * Remove Variant
     */
    async removeVariant(requestParameters: RemoveVariantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeVariantRaw(requestParameters, initOverrides);
    }

    /**
     * Confirm or reject a result, or clear an earlier decision with a null decision. Reviewers only: organizers, and for practice submissions the organization admin or workshop mentor of the author. Rejecting or clearing rejudges the submission; any flag is cleared.
     * Review Result
     */
    async reviewResultRaw(requestParameters: ReviewResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionResultReadWithOutput>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling reviewResult().'
            );
        }

        if (requestParameters['testCaseId'] == null) {
            throw new runtime.RequiredError(
                'testCaseId',
                'Required parameter "testCaseId" was null or undefined when calling reviewResult().'
            );
        }

        if (requestParameters['reviewDecisionUpdate'] == null) {
            throw new runtime.RequiredError(
                'reviewDecisionUpdate',
                'Required parameter "reviewDecisionUpdate" was null or undefined when calling reviewResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/{submission_id}/results/{test_case_id}/review`.replace(`{${"submission_id"}}`, encodeURIComponent(String(requestParameters['submissionId']))).replace(`{${"test_case_id"}}`, encodeURIComponent(String(requestParameters['testCaseId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReviewDecisionUpdateToJSON(requestParameters['reviewDecisionUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionResultReadWithOutputFromJSON(jsonValue));
    }

    /**
     * Confirm or reject a result, or clear an earlier decision with a null decision. Reviewers only: organizers, and for practice submissions the organization admin or workshop mentor of the author. Rejecting or clearing rejudges the submission; any flag is cleared.
     * Review Result
     */
    async reviewResult(requestParameters: ReviewResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionResultReadWithOutput> {
        const response = await this.reviewResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Run Submission
     */
    async runSubmissionRaw(requestParameters: RunSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling runSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/{submission_id}/run`.replace(`{${"submission_id"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Run Submission
     */
    async runSubmission(requestParameters: RunSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.runSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Score Submission
     */
    async scoreSubmissionRaw(requestParameters: ScoreSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling scoreSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/{submission_id}/score`.replace(`{${"submission_id"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Score Submission
     */
    async scoreSubmission(requestParameters: ScoreSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.scoreSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Withdraw the flag on a result. The author of the submission or a member of its team, or a reviewer dismissing the flag; the review decision is left unchanged.
     * Unflag Result
     */
    async unflagResultRaw(requestParameters: UnflagResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling unflagResult().'
            );
        }

        if (requestParameters['testCaseId'] == null) {
            throw new runtime.RequiredError(
                'testCaseId',
                'Required parameter "testCaseId" was null or undefined when calling unflagResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/submissions/{submission_id}/results/{test_case_id}/flag`.replace(`{${"submission_id"}}`, encodeURIComponent(String(requestParameters['submissionId']))).replace(`{${"test_case_id"}}`, encodeURIComponent(String(requestParameters['testCaseId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Withdraw the flag on a result. The author of the submission or a member of its team, or a reviewer dismissing the flag; the review decision is left unchanged.
     * Unflag Result
     */
    async unflagResult(requestParameters: UnflagResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unflagResultRaw(requestParameters, initOverrides);
    }

}
